export const getInitialState = (): any => ({
  uploadModelData: {},
  uploadModelStatus: 0
});
